<template>
  <div class="container pb-6 pb-8 pt-5 pt-md-8">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-header mt-4 text-center">
          <h2 class="mt-6 mb-6">Change Password</h2>

          <!-- Email -->
          <div class="col-md-12 text-left mt-4">
            <label for="First Name" class="form-control-title">Email</label>
            <span class="validation-error" v-if="!email && !isInputValid">* field required</span>
            <input class="form-control input" type="text" v-model="email" @input="onInputChanged()" />
          </div>
          <!--  -->
          <!-- Old Password -->
          <div class="col-md-12 text-left mt-4">
            <label for="Last Name" class="form-control-title">Old Password</label>
            <span class="validation-error" v-if="!oldPassword && !isInputValid">* field required</span>
            <input
              class="form-control input"
              type="password"
              v-model="oldPassword"
              @input="onInputChanged()"
            />
          </div>
          <!--  -->
          <!-- New Password -->
          <div class="col-md-12 text-left mt-4">
            <label for="Email" class="form-control-title">New Password</label>
            <span class="validation-error" v-if="!newPassword && !isInputValid">* field required</span>
            <input
              class="form-control input"
              type="password"
              v-model="newPassword"
              @input="onInputChanged()"
            />
          </div>
          <!--  -->
          <!-- Confrim Password -->
          <div class="col-md-12 text-left mt-4">
            <label for="Email" class="form-control-title">Confirm New Password</label>
            <span class="validation-error" v-if="!confirmPassword && !isInputValid">* field required</span>
            <input
              class="form-control input"
              type="password"
              v-model="confirmPassword"
              @input="onInputChanged()"
            />
          </div>
          <!--  -->
          <!-- Phone -->
          <!-- <div class="col-md-12 text-left mt-4">
            <label for="Phone" class="form-control-title">Phone</label>
            <input class="form-control input" type="text" value="010973923" />
          </div>-->
          <!--  -->
          <div class="col-md-12 mt-5 mb-4">
            <base-button type="primary" @click="onChangePasswordClicked()">Change Password</base-button>
          </div>

          <div class="text-center mt-5 mb-4" v-if="error">
            <span class="response-error">* {{ error }}</span>
          </div>
        </div>
      </div>
      <modal :show.sync="showModal" @close="onClose()">
        <h6 slot="header" class="modal-title" id="modal-title-default">Change Password</h6>
        <p class="text-dark">Your password has been changed !</p>

        <template slot="footer">
          <!-- <base-button type="primary">Save changes</base-button> -->
          <base-button type="link" class="text-center" @click="logout()">OK</base-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import {
  CHANGE_PASSWORD,
  RESET_AUTH_STATE,
  RESET_USER_STATE,
  RESET_LIVE_STREAM_STATE,
  RESET_COMMENT_STATE,
  RESET_NOTIFICATION_STATE,
  RESET_CLUB_STATE,
  RESET_SCHEDULE_STATE,
  LOGOUT
} from '@/store/actions.type'

export default {
  data() {
    return {
      email: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      isInputValid: true,
      showModal: false
    }
  },
  methods: {
    onChangePasswordClicked() {
      if (
        this.email &&
        this.oldPassword &&
        this.newPassword &&
        this.confirmPassword
      ) {
        if (this.newPassword !== this.confirmPassword) {
          this.$store.state.auth.errors =
            'New Password and Confirm Password must be the same'
        } else {
          this.$store
            .dispatch(CHANGE_PASSWORD, {
              email: this.email,
              oldPassword: this.oldPassword,
              newPassword: this.newPassword
            })
            .then(() => {
              this.showModal = true
            })
        }
      } else {
        this.isInputValid = false
      }
    },
    logout() {
      this.showModal = false
      Promise.all([
        this.$store.dispatch(RESET_AUTH_STATE),
        this.$store.dispatch(RESET_USER_STATE),
        this.$store.dispatch(RESET_LIVE_STREAM_STATE),
        this.$store.dispatch(RESET_COMMENT_STATE),
        this.$store.dispatch(RESET_NOTIFICATION_STATE),
        this.$store.dispatch(RESET_CLUB_STATE),
        this.$store.dispatch(RESET_SCHEDULE_STATE),
        this.$store.dispatch(LOGOUT)
      ]).then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    onClose() {
      this.logout()
    },
    onInputChanged() {
      this.$store.state.auth.errors = null
    }
  },
  computed: {
    ...mapState({
      error: state => {
        return state.auth.errors
      }
    })
  }
}
</script>

<style scoped>
.avatar-lg {
  width: 100px !important;
  height: 100px !important;
}

.form-control-title {
  margin-bottom: 0 !important;
  font-size: 12px !important;
  color: #666666 !important;
}
.btn:active,
.btn.active {
  background-image: none !important;
  outline: 0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.validation-error {
  color: #fb6340 !important;
  font-size: 14px;
  float: right;
}
</style>
